import { render, staticRenderFns } from "./VerticalBarChart.vue?vue&type=template&id=348570ad&scoped=true&"
import script from "./VerticalBarChart.vue?vue&type=script&lang=ts&"
export * from "./VerticalBarChart.vue?vue&type=script&lang=ts&"
import style0 from "./VerticalBarChart.vue?vue&type=style&index=0&id=348570ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348570ad",
  null
  
)

export default component.exports